import styles from './index.module.css';
import { logoBaseURL } from '../../../Utils/constants';
import { Divider, Typography } from 'antd';
import { ArrowDownOutlined } from '@ant-design/icons';
import { convertAmoutToINRWithNotation } from '../../../Utils/utils';
interface propsType {
  transaction: any;
  isLastTransaction: boolean;
}
const TransactionCard = ({ transaction, isLastTransaction }: propsType) => {
  const txn1 = transaction.displayName.split('-');
  return (
    <>
      <div className={styles.transactionCard} id={transaction.uniqueId}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <div className={styles.image_container}>
            <img
              src={logoBaseURL + transaction.merchantLogoCode + '.jpg'}
              height={32}
              style={{ objectFit: 'contain' }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                marginTop: 10,
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <Typography.Text
                style={{
                  color: 'rgb(40, 57, 100)',
                  fontWeight: 500,
                }}
              >
                {txn1 && txn1.length >= 2 ? txn1[1] : txn1[0]}
              </Typography.Text>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <Typography.Text
                style={{
                  fontSize: '12px',
                }}
              >
                {transaction['narration']}
              </Typography.Text>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <Typography.Text
                style={{
                  color: 'rgba(117,119,121)',
                  fontSize: '12px',
                }}
              >
                {txn1 && txn1.length > 1 ? txn1[0] : 'Others'}
                {/* {dayjs(transaction.dateOfTransaction).format('DD MMM YYYY')} */}
              </Typography.Text>
            </div>
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            maxWidth: '30%',
            justifyContent: 'flex-end',
          }}
        >
          <Typography.Text style={{ fontWeight: 500, wordBreak: 'keep-all' }}>
            ₹{convertAmoutToINRWithNotation(transaction.amount)}
          </Typography.Text>
          {transaction.type === 'CREDIT' ? (
            <ArrowDownOutlined className={styles.creditArrow} />
          ) : (
            <ArrowDownOutlined className={styles.debitArrow} />
          )}
        </div>
      </div>
      {isLastTransaction ? <Divider style={{ margin: '6px 0px' }} /> : <></>}
    </>
  );
};

export default TransactionCard;
